module.exports = __webpack_public_path__ + "static/img/download.94df496f.svg";